import { useContent } from '../../top-navigation.context';
import { Popover } from '../popover/popover';
import { Option } from '../types';

type LanguageSwitcherProps = {
  options: Option[];
  selectedValue: string;
  renderLink: (option: Option) => JSX.Element;
};
export const LanguageSwitcher = ({ options, selectedValue, renderLink }: LanguageSwitcherProps) => {
  const { language } = useContent();

  return (
    <Popover.List title={language}>
      {options.map((option) => {
        return (
          <Popover.ListItem key={option.value} isSelected={option.value === selectedValue}>
            <Popover.Close>{renderLink(option)}</Popover.Close>
          </Popover.ListItem>
        );
      })}
    </Popover.List>
  );
};
